import { mediaQuery } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

const getDefaultColorStyles = variant => {
  if (variant === 'contained') {
    return {
      borderColor: 'transparent',
      '&:hover': { backgroundColor: ({ palette }) => palette.primary.dark },
    };
  }

  return {
    borderColor: ({ palette }) => palette.primary.main,
    color: ({ palette }) => palette.primary.main,
    '&:hover': {
      borderColor: ({ palette }) => palette.primary.main,
      backgroundColor: ({ palette }) => palette.primary.soft,
    },
  };
};

const compactButtonStyles = {
  height: '32px',
  padding: '4px 12px',
  minWidth: 'unset',
  lineHeight: '1.4rem',
  fontSize: '1.2rem',
  fontWeight: 400,
};

export const getButtonStyles = ({ customStyles, colorStyles, variant, isCompact = true }) => ({
  ...getConditionalObject(isCompact, compactButtonStyles),
  textTransform: 'none',
  whiteSpace: 'nowrap',
  borderRadius: '8px',
  border: '1px solid',
  ...(!colorStyles || Object.keys(colorStyles).length === 0
    ? getDefaultColorStyles(variant)
    : colorStyles),
  ...customStyles,

  // Touch target floor on mobile: grow the hit area to >=44pt while the (compact) glyph/label and
  // the desktop height/width above stay intact. Appended last so it wins over `customStyles`.
  [mediaQuery.mobile]: {
    minHeight: '44px',
    minWidth: '44px',
  },
});

export const dividerStyles = {
  height: '32px',
  borderColor: ({ palette }) => palette.border.default,
};
